import { useFilterTierLevelContext } from "./filter-tier-level.context";

export function FilterTierLevel() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterTierLevelContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}